module.exports = __webpack_public_path__ + "media/images/business/i-online-2ea2c30ed0ffb1f8cefe74d37d6cbff1.svg";